<template>
  <div class="home">
    <div class="head">
      <div class="logo">
        <img :src="`${publicPath}/images/Pangus-logo.png`" alt="" />
      </div>
      <p>数字化智能制造系统领航者</p>
    </div>
    <div class="bottom">
      <div class="bottom-box">
        <div
          v-for="(item, index) in boxVideoImg"
          :key="index"
          class="bottom-box-font-box"
          @click="showDialog(item['videoUrl'])"
        >
          <span class="bottom-box-font">{{ item["fontTitle"] }}</span>
          <img
            :src="`${publicPath}${item['imgUrl']}`"
            alt=""
            class="bottom-box-font-img"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- 弹窗部分 -->

  <!-- <Dialog v-model:visible="imgVisible" @hideDialog="hideDialog">
    <div class="videoDialog-box">
      <video
        class="videoDialog"
        controls
        autoplay
        ref="videoDom"
        :src="`${publicPath}${visibleVideoSrc}`"
      >
      </video>
    </div>
  </Dialog> -->
</template>

<script>
import Dialog from "../components/Dialog.vue";
export default {
  name: "home",
  components: { Dialog },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      boxVideoImg: [],
      // //弹窗视频菜单
      // visibleVideoSrc: null,
      // // 显示弹窗
      // visible: false,
      // imgVisible: false,
    };
  },
  methods: {
    //打开弹窗
    showDialog(item) {
      // console.log(item);
      // this.imgVisible = true;
      // this.visibleVideoSrc = item;
      const newPageUrl = `${this.publicPath}${item}`;
      window.open(newPageUrl, "_blank");
    },
    hideDialog() {
      // this.$refs.videoDom.pause();
      if (this.$refs.videoDom) {
        this.$refs.videoDom.pause();
      }
    },
  },
  created() {
    this.ajax.get(this.publicPath + "/data.json").then((res) => {
      console.log(res, "res");
      this.boxVideoImg = res.data[0].home.boxVideoImg;
      console.log(this.boxVideoImg, "ahsdhasdhas");
    });
  },
};
</script>

<style scoped>
.home {
    width: 100%;
    height: 100%;
    background-image: url(../images/video_bg.png);
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: 50%;
    background-size: cover;
    overflow: auto;
}
.head .logo {
  width: 8rem;
  height: 2.4rem;
  margin-left: 1.25rem;
}
.logo img {
  width: 100%;
  height: 100%;
}
.head {
  height: 5rem;
  display: flex;
  width: 100%;
  padding: 0.5rem;
  align-items: center;
}

.head p {
  margin-left: auto;
  color: #fff;
  font-size: 1.8rem;
  line-height: 2.4rem;
  margin-right: 1rem;
  padding: 0.15rem;
  font-weight: 800;
}

.bottom {
  width: 90%;
  height: calc(100% - 5rem);
  margin: auto;
}
.bottom-box {
    display: flex;
    flex-wrap: wrap;
    /* overflow: auto; */
}
.bottom-box div {
  width: 33.33333%;
  padding: 0.5rem;
}
.bottom-box-font-img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  /* transition: all 0.3s; */
}

.videoDialog-box  {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.videoDialog-box video{
  width: 80%;
  height: 80%;
  }
.bottom-box-font-box {
  position: relative;
  transition: all 0.3s;
}
.bottom-box-font-box:hover {
  transform: scale(1.1);
}

.bottom-box-font {
    position: absolute;
    height: 3rem;
    left: 0.95rem;
    top: 2rem;
    margin: 0 2rem;
    cursor: pointer;
    line-height: 3rem;
    font-size: 2rem;
    color: #fff;
    font-weight: 800;
    text-shadow: 0 0.26rem 0.25rem grey;
}
</style>